import { render, staticRenderFns } from "./IframeBlock.vue?vue&type=template&id=09d5daad"
import script from "./IframeBlock.vue?vue&type=script&lang=js"
export * from "./IframeBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports